import React, { useEffect, useState } from "react";
import { ordinalSuffix, toDateString } from "../../../common/helper";
import IconNotes from "../../../layout/others/icon_notes.svg";
import { ReactComponent as IconStar } from "../../../layout/others/icon_star_idle.svg";
import { useInterviewContext } from "../InterviewContext";
import { useHistory } from "react-router-dom";
import "../Interview.scss";
import { useTranslation } from "react-i18next";
import { InterviewService } from "../../../services/InterviewService";

const InterviewHistory = ({ interview, interviewHistory }) => {
  const SCREENCALLORDER = 0;

  const { t } = useTranslation();
  const [preCandidateContacts, setPreCandidateContacts] = useState([]);
  const [alertsToCandidate, setAlertsToCandidate] = useState([]);

  const [tabNameActive, setTabNameActive] = useState("interviewHistory-tab");
  let history = useHistory();

  useEffect(() => {
    if (preCandidateContacts.length === 0) {
      getPreCandidateContacts();
    }
  }, []);

  useEffect(() => {
    if (alertsToCandidate.length === 0) {
      getAlertsToCandidate();
    }
  }, []);

  const openReadOnlyInterviewHistory = (interviewId) => {
    history.push(`/interview/view/${interviewId}?returnUrl=/interview`);
  };

  const getPreCandidateContacts = () => {
    InterviewService.getPreCandidatesContacts(interview.interviewId).then(
      (result) => {
        setPreCandidateContacts(result);
      }
    );
  };

  const getAlertsToCandidate = () => {
    InterviewService.getAlertsToCandidate(interview.interviewId).then(
      (result) => {
        setAlertsToCandidate(result);
      }
    );
  };

  const onClickSetTabActive = (tabName) => {
    setTabNameActive(tabName);
  };

  return (
    <div>
      <ul className="nav nav-tabs" id="history" role="tablist">
        <li className="nav-item" role="presentation">
          <button
            className={
              tabNameActive === "interviewHistory-tab"
                ? "nav-link active"
                : "nav-link"
            }
            id="interviewHistory-tab"
            data-bs-toggle="tab"
            data-bs-target="#interviewHistory-tab"
            href="#interviewHistory"
            type="button"
            role="tab"
            aria-controls="interviewHistory"
            aria-selected="true"
            onClick={() => onClickSetTabActive("interviewHistory-tab")}
          >
            <img
              src={IconNotes}
              alt="ico-notes"
              height="14px"
              width="auto"
              style={{ marginRight: "4px" }}
            />
            {t("Notes")}
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={
              tabNameActive === "preCandidateContacts-tab"
                ? "nav-link active"
                : "nav-link"
            }
            id="preCandidateContacts-tab"
            data-bs-toggle="tab"
            data-bs-target="#preCandidateContacts-tab"
            href="#preCandidateContactsTab"
            type="button"
            role="tab"
            aria-controls="preCandidateContactsTab"
            aria-selected="false"
            onClick={() => onClickSetTabActive("preCandidateContacts-tab")}
          >
            <img
              src={IconNotes}
              alt="ico-notes"
              height="14px"
              width="auto"
              style={{ marginRight: "4px" }}
            />
            {t("Precandidate-Contacts")}
          </button>
        </li>
        <li className="nav-item" role="presentation">
          <button
            className={
              tabNameActive === "alerts-tab" ? "nav-link active" : "nav-link"
            }
            id="alerts-tab"
            data-bs-toggle="tab"
            data-bs-target="#alerts-tab"
            href="#alerts"
            type="button"
            role="tab"
            aria-controls="alertsTab"
            aria-selected="false"
            onClick={() => onClickSetTabActive("alerts-tab")}
          >
            <img
              src={IconNotes}
              alt="ico-notes"
              height="14px"
              width="auto"
              style={{ marginRight: "4px" }}
            />
            {t("Alerts")}
          </button>
        </li>
      </ul>
      <div className="tab-content" id="historyTabContent">
        <div
          className={
            tabNameActive === "interviewHistory-tab"
              ? "tab-pane fade show active"
              : "tab-pane fade"
          }
          id="interviewHistory"
          role="tabpanel"
          aria-labelledby="interviewHistory-tab"
        >
          {interviewHistory.map((item) => (
            <div className="history-notes row">
              {item.type === "interview-history" && (
                <div
                  className="add-section col-12"
                  onClick={() => {
                    openReadOnlyInterviewHistory(item.interviewId);
                  }}
                >
                  <h5>
                    {item.order == SCREENCALLORDER
                      ? "Screen Call"
                      : item.order +
                        t(`${ordinalSuffix(item.order)} Interview`)}
                  </h5>
                </div>
              )}
              {item.type === "interview-contact" && (
                <div className="col-12">
                  <h5>
                    {item.order + t(`${ordinalSuffix(item.order)} Contact`)}
                  </h5>
                </div>
              )}
              <div id="managerName" className="col-4">
                <b>{item.createdBy_ManagerName}</b>
              </div>
              {item.type === "interview-history" && (
                <div id="ranking" className="col-4 text-end">
                  <IconStar /> {item.ranking}
                </div>
              )}
              {item.type === "interview-contact" && (
                <div id="ranking" className="col-4 text-end" />
              )}
              <div id="created-date" className="col-4 text-end">
                {toDateString(item.createdDate)}
              </div>
              <div id="notes" className="col-12">
                <div>{item.notes}</div>
              </div>
              <div className="col-6">
                <b>Last Modified:</b> {item.lastUpdateBy_ManagerName}
              </div>
              <div id="update-date" className="col-6 text-end">
                {item.lastUpdateDate && toDateString(item.lastUpdateDate)}
              </div>
            </div>
          ))}
        </div>
        <div
          className={
            tabNameActive === "preCandidateContacts-tab"
              ? "tab-pane fade show active"
              : "tab-pane fade"
          }
          id="preCandidateContactsTab"
          role="tabpanel"
          aria-labelledby="preCandidateContacts-tab"
        >
          {preCandidateContacts.map((item) => {
            return (
              <div className={`history-notes ${item.entityType}`}>
                <div className="head">
                  <div id="entity-type">
                    <strong>
                      {`${item.entityNumber}`}
                      {t(
                        ordinalSuffix(item.entityNumber) + " " + item.entityType
                      )}
                    </strong>
                  </div>
                  <div
                    className="text-truncate"
                    id="username"
                    title={item.userName}
                  >
                    {item.userName}
                  </div>
                  <div id="created-date">{toDateString(item.createdDate)}</div>
                </div>
                {item.notes && (
                  <div id="notes">
                    <strong>{t("Notes") + ":"}</strong>
                    <div>{item.notes}</div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div
          className={
            tabNameActive === "alerts-tab"
              ? "tab-pane fade show active"
              : "tab-pane fade"
          }
          id="alertsTab"
          role="tabpanel"
          aria-labelledby="alerts-tab"
        >
          {alertsToCandidate.map((item) => {
            return (
              <div className="history-notes row">
                <div className="head">
                  <strong>{toDateString(item.createdDate)}</strong>
                </div>
                <div
                  className="card-text"
                  dangerouslySetInnerHTML={{ __html: item.message }}
                ></div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default InterviewHistory;
